import { privateFetch } from "api/privateFetch";

/**
 * To get whether user has unread messages
 * @param {number} id User ID
 * @returns {Promise<boolean>} True or False
 */
const hasUnreadMessage = async (id) => {
  const { data } = await privateFetch.get(`/chat/${id}/unreadmessage`);
  return data;
};

export default hasUnreadMessage;
